/*
 * Javascript for the home page
*/
import { getCookie, setCookie, screen_xs, screen_sm, screen_md } from './utils.js';

(function($) {
	console.log('Screen sizes:', {
		xs: screen_xs,
		sm: screen_sm,
		md: screen_md
	});


	$(document).on('click','.signup input[type="text"], .signup input[type="email"]',function(e) {
		$('.dataprotection').removeClass('hidden');
	});

	// Hide Signup on on scroll down
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('.signup').outerHeight();
	var signup_close = false;

	if($('.signup').length) {
		$(window).scroll(function(event){
			hasScrolled();
		});
	}

	function hasScrolled() {
		const mediaQuery = window.matchMedia('(min-width: '+screen_sm+'px)');
		
		/*
		Not showing due to Dynamics issues
		if((!signup_close) && ((window.consent_status == true)||(!mediaQuery.matches))) {
			console.log('hasScrolled2');
			var st = $(this).scrollTop();

			// Make sure they scroll more than delta
			if(Math.abs(lastScrollTop - st) <= delta)
				return;

			// If they scrolled down and are past the navbar, add class .nav-up.
			// This is necessary so you never see what is "behind" the navbar.
			if (st > lastScrollTop && st > navbarHeight){
				// Scroll Down
				$('.signup').removeClass('appear').addClass('disappear');
			} else {
				// Scroll Up
				if(st + $(window).height() < $(document).height()) {
					$('.signup').removeClass('disappear').addClass('appear');
				}
			}
			lastScrollTop = st;
		} else {
			$('.signup').removeClass('appear').addClass('disappear');
		}
		*/
	}

	$(document).on('click','.signup button.btn-reset',function(e) {
		setCookie('signup', 'close', 999);
		signup_close = true;
		$('.signup').removeClass('appear').addClass('disappear');
	});
	$(document).ready(function() {
		close = getCookie('signup');
		if(close == 'close') {
			signup_close = true;
			$('.signup').removeClass('appear').addClass('disappear');
		}
	});

	

	$(document).on('click','.mob-popup',function() {
		$(this).remove();
		$('.signup-form').removeClass('hidden');
	});

})(jQuery);
